import { Component, OnInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { MatSnackBar } from "@angular/material/snack-bar";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { BoardResponseModel } from "src/app/model/BoardResponseModel";
import { MasterService } from "src/app/services/master.service";

@Component({
  selector: 'app-secure-board-au',
  templateUrl: './board-au.component.html',
  styleUrls: ['./board-au.component.scss'],
})
export class BoardAUComponent implements OnInit {

  boardKey: number;
  pageMode: string;
  boardResponseModel : BoardResponseModel;
  form: FormGroup = new FormGroup({});
  isSubmitDisabled: boolean = false;
  boardLogoFile: File;
  organizationList: {[key:number]:string};
  boardLogoData: string | ArrayBuffer;

  constructor(
    private masterService: MasterService,
    private _snackBar: MatSnackBar,
    private route: ActivatedRoute,
    private router: Router
  ) {} 

  ngOnInit() {
    this.route.params.subscribe((params: Params) => {
      this.boardKey = +params["key"];
     
      this.masterService
        .initBoardForm()
        .subscribe((data: any) => {
          if(data.status === 'SUCCESS') {
            this.organizationList = data.organizations;
            console.log(this.organizationList);
            if(this.boardKey) {
              console.log("Board key get for edit " + this.boardKey);
              this.masterService
              .getBoardBykey(this.boardKey)
              .subscribe((data: any) => {
                this.boardResponseModel = data;
                this.pageMode = "Edit";
                console.log('form mode Edit');
                this.form.setValue({
                  boardCode: this.boardResponseModel.boardCode,
                  boardName: this.boardResponseModel.boardName,
                  orgKey:  {key: this.boardResponseModel.orgKey},
                  boardReportName: this.boardResponseModel.boardReportName,
                  boardReportNameMr: this.boardResponseModel.boardReportNameMr
                });

                this.boardLogoData = this.boardResponseModel.boardLogoResource;
              });
            }
            else {
              this.pageMode = "Add";
              console.log('form mode add');
            }
          }
          else {
            //toast data.errorMessage
          }
        });

      this.form = new FormGroup({
        boardCode: new FormControl(null, Validators.required),
        boardName: new FormControl(null, Validators.required),
        orgKey: new FormControl(null, Validators.required),
        boardReportName: new FormControl(null, Validators.required),
        boardReportNameMr: new FormControl(null, Validators.required),
      });
    });
  }


  onFileSelect(event) {
    this.boardLogoData = null;
    this.boardLogoFile = event.target.files[0];

    const reader = new FileReader();
    reader.readAsDataURL(this.boardLogoFile);
    reader.onload = () => {
      //console.log('file base64', reader.result);
      this.boardLogoData = reader.result;
    };
  }

  onSubmit() {
    if(this.pageMode === 'Add') {
      this.saveBoard();
    }
    else {
      this.updateBoard();
    }
  }

  async saveBoard() {
    console.log("file name"+this.form.value.boardLogoFile);
    if (this.form.valid) {
      const reader = new FileReader();
      reader.readAsDataURL(this.boardLogoFile);
      reader.onload = () => {
        //console.log('file base64', reader.result);
        this.masterService
        .saveBoard({
          boardCode: this.form.value.boardCode,
          boardName: this.form.value.boardName,
          boardLogoFile: reader.result,
          orgKey: this.form.value.orgKey?.key
        })
        .subscribe((data: any) => {
            if(data.status === 'SUCCESS') {
              this.successToast();
              this.router.navigate(["/secure", "master", "board", "list"]);
            }
            else {
              this.isSubmitDisabled = false;
              this.errorToast(data.errorMessage);
            }
          }, error => {
            this.isSubmitDisabled = false;
            console.log(error);
            this.errorToast(error.error.errorMessage, 5*1000);
          });
      };
    } else {
      this.isSubmitDisabled = false;
      this.errorToast("");
    }
  }


  async updateBoard() {
    console.log("chaking values"+this.form.value);
    if (this.form.valid) {
      const reader = new FileReader();
      reader.readAsDataURL(this.boardLogoFile);
      reader.onload = () => {
        console.log('file base64', reader.result);
        this.masterService
      .updateBoard(this.boardKey, {
        boardCode: this.form.value.boardCode,
        boardName: this.form.value.boardName,
        boardLogoFile: reader.result,
        orgKey: this.form.value.orgKey?.key
      })
        .subscribe((data: any) => {
            if(data.status === 'SUCCESS') {
              this.successToast();
              this.router.navigate(["/secure", "master", "board", "list"]);
            }
            else {
              this.isSubmitDisabled = false;
              this.errorToast(data.errorMessage);
            }
          }, error => {
            this.isSubmitDisabled = false;
            console.log(error);
            this.errorToast(error.error.errorMessage, 5*1000);
          });
      };
    } else {
      this.isSubmitDisabled = false;
      this.errorToast("");
    }
  }





  async successToast() {
    await this._snackBar.open(
      "Board details saved successfully.",
      "Close",
      {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "success-toast",
        duration: 3 * 1000,
      }
    );
  }

  async warningToast() {
    await this._snackBar.open("Please Upload Logo", "Close", {
      horizontalPosition: "right",
      verticalPosition: "top",
      panelClass: "warning-toast",
      duration: 3 * 1000,
    });
  }

  async errorToast(errorMessage: string, dur?: number) {
    await this._snackBar.open(errorMessage, "Close", {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "error-toast",
        duration: dur ? dur : 3 * 1000,
      }
    );
  }

  showOrganization(o1: any, o2: any) {
    if(o1 && o2 && o1.key == o2.key) {
      return o1.value;
    }
    else {
      return "";
    }
  }


  // async saveCategory() {
  //   const response: any = this.boardService.saveCategory(this.catNameEng, this.catNameMar);
  //   console.log(response);
  //   if (!response.error) {
  //     if (response.length > 0) {
  //       this.successToast();
  //     } else {
  //       this.warningToast();
  //     }
  //   } else {
  //     this.errorToast();
  //   }
  // }

  // async successToast() {
  //   await this._snackBar.open("Category details saved successfully.", "Close", {
  //     horizontalPosition: "right",
  //     verticalPosition: "top",
  //     panelClass: "success-toast",
  //     duration: 3 * 1000,
  //   });
  // }

  // async warningToast() {
  //   await this._snackBar.open(
  //     "Something went wrong while saving category details, please try again after sometime.",
  //     "Close",
  //     {
  //       horizontalPosition: "right",
  //       verticalPosition: "top",
  //       panelClass: "warning-toast",
  //       duration: 3 * 1000,
  //     }
  //   );
  // }

  // async errorToast() {
  //   await this._snackBar.open("Oops, something went wrong, please try after sometime.", "Close", {
  //     horizontalPosition: "right",
  //     verticalPosition: "top",
  //     panelClass: "error-toast",
  //     duration: 3 * 1000,
  //   });
  // }

}
